var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-scrollbar__wrap" }, [
    _c("div", { staticClass: "el-scrollbar__view" }, [
      _c(
        "div",
        { staticClass: "analyze" },
        [
          _c(
            "el-row",
            { staticClass: "m-3" },
            [_c("quota-explain", { attrs: { info: _vm.topCard } })],
            1
          ),
          _c(
            "el-row",
            { staticClass: "m-3" },
            [
              _c("chart-card", [
                _c(
                  "div",
                  {
                    staticClass: "relative",
                    attrs: { slot: "card-head" },
                    slot: "card-head",
                  },
                  [
                    _c(
                      "el-tabs",
                      {
                        model: {
                          value: _vm.tabs.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabs, "name", $$v)
                          },
                          expression: "tabs.name",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "销售额", name: "cellNum" } },
                          [_c("cell-num", { ref: "cellNum" })],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "访问量", name: "visitNum" } },
                          [_c("visit-num", { ref: "visitNum" })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex float-left absolute top-1 right-0" },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [_vm._v("今日")]
                                    ),
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [_vm._v("本周")]
                                    ),
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [_vm._v("本月")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-3",
                                        attrs: { type: "text" },
                                      },
                                      [_vm._v("本年")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "~",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                  },
                                  model: {
                                    value: _vm.chart.range,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.chart, "range", $$v)
                                    },
                                    expression: "chart.range",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "m-3" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "card-panel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-panel-icon-wrapper icon-location",
                        },
                        [
                          _c("i", {
                            staticClass:
                              "el-icon-platform-eleme card-panel-icon",
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "card-panel-description" },
                        [
                          _c("div", { staticClass: "card-panel-text" }, [
                            _vm._v(" 访问量 "),
                          ]),
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": _vm.info.ipVisit.num,
                              duration: _vm.info.ipVisit.duration,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "card-panel" }, [
                      _c(
                        "div",
                        { staticClass: "card-panel-icon-wrapper icon-sell" },
                        [
                          _c("i", {
                            staticClass:
                              "el-icon-shopping-cart-2 card-panel-icon",
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "card-panel-description" },
                        [
                          _c("div", { staticClass: "card-panel-text" }, [
                            _vm._v(" 销售量 "),
                          ]),
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": _vm.info.timesVisit.num,
                              duration: _vm.info.timesVisit.duration,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "card-panel" }, [
                      _c(
                        "div",
                        { staticClass: "card-panel-icon-wrapper icon-visit" },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-order card-panel-icon",
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "card-panel-description" },
                        [
                          _c("div", { staticClass: "card-panel-text" }, [
                            _vm._v(" 订单量 "),
                          ]),
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": _vm.info.totalVisit.num,
                              duration: _vm.info.totalVisit.duration,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "card-panel" }, [
                      _c(
                        "div",
                        { staticClass: "card-panel-icon-wrapper icon-people" },
                        [
                          _c("i", {
                            staticClass: "el-icon-user-solid card-panel-icon",
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "card-panel-description" },
                        [
                          _c("div", { staticClass: "card-panel-text" }, [
                            _vm._v(" 新用户 "),
                          ]),
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": _vm.info.totalVisit.num,
                              duration: _vm.info.totalVisit.duration,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-row", { attrs: { gutter: 15 } }, [
            _c("div", { staticClass: "card-panel" }, [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-location" },
                [_c("i", { staticClass: "el-icon-setting card-panel-icon" })]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "left",
                    "margin-top": "20px",
                    float: "left",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "font-size": "large",
                      },
                    },
                    [_vm._v("Web端更新：" + _vm._s(_vm.front_git_commitTime))]
                  ),
                  _c("br"),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "font-size": "large",
                      },
                    },
                    [_vm._v("Web端版本：" + _vm._s(_vm.front_git_commitId))]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "left",
                    "margin-top": "20px",
                    float: "left",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "font-size": "large",
                      },
                    },
                    [_vm._v("服务端更新：" + _vm._s(_vm.back_git_commitTime))]
                  ),
                  _c("br"),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "font-size": "large",
                      },
                    },
                    [_vm._v("服务端版本：" + _vm._s(_vm.back_git_commitId))]
                  ),
                ]
              ),
              _c("div", { staticStyle: { clear: "both" } }),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }